import styled from 'styled-components'
import { Box } from '@usap/uicomponents'

export const StaticSidebarMainContainer = styled(Box)`
  position: sticky;
  z-index: 1;
  top: 10px
`

export const StaticSidebarInnerContainer = styled(Box)`
  margin-bottom: 16px;
`

